import { defineType } from "sanity";
import { SectionAnchorInput } from "../../../components/SectionAnchorInput";
import { multilingualStringPreview } from "../../base/multilingualArrayString";

export default defineType({
  name: "anchorCTA",
  type: "object",
  title: "Anchor CTA",

  fields: [
    {
      name: "label",
      type: "multilingualArrayString"
    },
    {
      type: "string",
      name: "target",
      title: "Target",
      components: {
        input: SectionAnchorInput
      }
    },
    {
      name: "type",
      type: "buttonType"
    }
  ],
  preview: {
    select: {
      title: "label"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || "Anchor CTA"
      };
    }
  }
});
